interface HttpErrorDetail {
  readonly code?: string;
}

interface HttpErrorBody {
  readonly error?: string | HttpErrorDetail;
}

export const getHttpErrorCode = (body: unknown): string => {
  if (!body || typeof body !== "object") {
    return "";
  }

  const errorBody = body as HttpErrorBody;
  const error = errorBody.error;

  if (typeof error === "string") {
    return error;
  }

  if (error && typeof error === "object" && typeof error.code === "string") {
    return error.code;
  }

  return "";
};
